import { JWT_TOKEN } from "@/constants/local-storage-keys";
import { decodeJWT } from "@/utils/encoders/encoders";

let appInstanceId = null;
export function setCurrentAppInstanceId(id) {
  appInstanceId = id;
}

export function setToken(token) {
  if (token) {
    if (appInstanceId) {
      localStorage.setItem(`${JWT_TOKEN}:${appInstanceId}`, token);
    } else {
      localStorage.setItem(JWT_TOKEN, token);
    }
  }
}

export function getStoredToken() {
  if (appInstanceId) {
    const appToken = localStorage.getItem(`${JWT_TOKEN}:${appInstanceId}`);
    if (appToken) return appToken;
  }
  return localStorage.getItem(JWT_TOKEN);
}

export function removeToken() {
  localStorage.removeItem(JWT_TOKEN);
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`${JWT_TOKEN}:`)) {
      const { expiration } = decodeJWT(localStorage.getItem(key));
      if (
        typeof expiration === "number" &&
        expiration * 1000 < new Date().getTime()
      ) {
        localStorage.removeItem(key);
      }
    }
  });
}
